import API_SERVER from '../api/server'
const io = require('socket.io-client')

const socket = io(API_SERVER, {
   withCredentials: true,
   secure: true,
   reconnection: true,
   rejectUnauthorized: false,
   transports: ['polling'],
   reconnectionDelay: 1000,
   reconnectionAttempts: 10,
   agent: false,
   upgrade: false
})

export default socket
